import React, { FC, useMemo } from 'react';

import { useFormikContext } from 'formik';

import BasicButton from '../../../../../../components/buttons/basicButton';
import styled from 'styled-components';

import aampeTheme from '../../../../../../constants/aampeTheme';
import ICONS from '../../../../../../constants/icons';
import { androidAddButtonElement } from './constants';

import { NotificationButtonFormValues } from '../../../../../../models/formula.model';

const AndroidFieldAddNewButton: FC = () => {
    const { setFieldValue, values, isValid } =
        useFormikContext<NotificationButtonFormValues>();

    const { androidButtons, androidToggle } = values;

    const isLastButtonFilled = useMemo<boolean>(() => {
        const lastButton = androidButtons?.[androidButtons.length - 1];
        return lastButton?.text !== '' && lastButton?.action !== '';
    }, [androidButtons]);

    const handleAddNewButton = () => {
        if (values?.androidButtons?.length! < 3) {
            setFieldValue('androidButtons', [
                ...androidButtons!,
                { ...androidAddButtonElement },
            ]);
        }
    };
    return (
        <AddButton
            isPrimary={false}
            isBorder={false}
            icon={<ICONS.plus size={14} />}
            name="Add button"
            action={handleAddNewButton}
            isDisabled={
                !androidToggle ||
                !isValid ||
                !isLastButtonFilled ||
                androidButtons?.length === 3
            }
        />
    );
};

const AddButton = styled(BasicButton)({
    display: 'flex',
    cursor: 'pointer',
    padding: aampeTheme.spacing4(0),
});
export default AndroidFieldAddNewButton;
